import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../hooks/ThemeContext";
import { Home, ArrowLeft, Search } from "lucide-react";

function NotFound() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  return (
    <div className={`flex-1 flex flex-col items-center justify-center px-4 py-16 ${isDark ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
      <div className="text-center max-w-2xl">
        {/* 404 Illustration */}
        <div className="mb-8">
          <h1 className={`text-9xl font-bold ${isDark ? 'text-rose-500' : 'text-rose-600'} mb-4`}>
            404
          </h1>
          <div className="flex items-center justify-center gap-4 mb-4">
            <Search className={`w-12 h-12 ${isDark ? 'text-gray-600' : 'text-gray-400'}`} />
          </div>
        </div>

        {/* Message */}
        <h2 className="text-3xl font-bold mb-4">Page introuvable</h2>
        <p className={`text-lg mb-8 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Oups ! La page que vous recherchez n'existe pas ou vous n'y avez pas accès.
        </p>

        {/* Suggestions */}
        <div className={`p-6 rounded-lg border mb-8 ${isDark ? 'bg-[#0b0b0c] border-white/10' : 'bg-white border-gray-200'}`}>
          <p className={`text-sm mb-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            Quelques suggestions :
          </p>
          <ul className={`text-sm space-y-2 text-left ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            <li>• Vérifiez l'URL saisie</li>
            <li>• Retournez à la page d'accueil</li>
            <li>• Contactez-nous si le problème persiste</li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-colors ${
              isDark 
                ? 'bg-rose-500 text-white hover:bg-rose-600' 
                : 'bg-rose-600 text-white hover:bg-rose-700'
            }`}
          >
            <Home className="w-5 h-5" />
            Retour à l'accueil
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg border font-medium transition-colors ${
              isDark 
                ? 'border-white/10 hover:bg-white/5' 
                : 'border-gray-200 hover:bg-gray-50'
            }`}
          >
            <ArrowLeft className="w-5 h-5" />
            Page précédente
          </button>
        </div>

        {/* Contact */}
        <div className="mt-8">
          <p className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
            Besoin d'aide ?{' '}
            <Link to="/contact" className={`${isDark ? 'text-rose-400 hover:text-rose-300' : 'text-rose-600 hover:text-rose-700'} underline`}>
              Contactez-nous
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
